export function mix(colorA: number[], colorB: number[], progress: number) {
    const result = []

    for (let i = 0; i < colorA.length; i++) {
        result.push(
            Math.max(
                Math.min(
                    Math.floor(
                        colorA[i] * (1 - progress) + colorB[i] * progress,
                    ),
                    255,
                ),
                0,
            ),
        )
    }

    return result
}

export function colorToString(color: number[]) {
    let result = '#'

    for (const element of color) {
        if (element < 16) {
            result += '0'
        }
        result += element.toString(16)
    }

    return result
}
